/**
 * Volume pricing for gourmet sets (corporate / bulk orders): the more sets of
 * one listing in an order, the lower the price per set. Only the shops listed
 * in BULK_SHOP_IDS take part.
 *
 * Every helper takes the listing as { category, shopId }.
 *
 * Keep in sync with server/api-util/bulkPricing.js — the server recomputes
 * every price at checkout, this copy only drives what the buyer sees.
 */

export const BULK_CATEGORY = 'Gourmet_Sets';

// Gourmet Baskets
export const BULK_SHOP_IDS = ['68e2bc2f-0209-470c-a0aa-85de0d876452'];

// Ascending by minQty.
export const BULK_TIERS = [
  { minQty: 5, pct: 10 },
  { minQty: 20, pct: 20 },
  { minQty: 50, pct: 30 },
  { minQty: 100, pct: 40 },
];

export const BULK_MAX_QTY = 300;
export const DEFAULT_MAX_QTY = 99;

export const hasBulkPricing = ({ category, shopId } = {}) =>
  category === BULK_CATEGORY && BULK_SHOP_IDS.includes(shopId);

export const bulkDiscountPct = (listing, qty) => {
  if (!hasBulkPricing(listing)) return 0;
  const tier = [...BULK_TIERS].reverse().find(t => qty >= t.minQty);
  return tier ? tier.pct : 0;
};

// Price per set in cents for the given quantity.
export const bulkUnitPrice = (amount, listing, qty) =>
  Math.round((amount * (100 - bulkDiscountPct(listing, qty))) / 100);

// Lowest possible price per set (the top tier) — shown as "From $X" on cards.
export const minUnitPrice = (amount, listing) =>
  hasBulkPricing(listing)
    ? bulkUnitPrice(amount, listing, BULK_TIERS[BULK_TIERS.length - 1].minQty)
    : amount;

// How many sets one order line may hold: the category cap, or the tracked
// stock when that is lower.
export const maxQtyFor = (listing, stock) => {
  const cap = hasBulkPricing(listing) ? BULK_MAX_QTY : DEFAULT_MAX_QTY;
  return typeof stock === 'number' && stock > 0 ? Math.min(cap, stock) : cap;
};
